<template>
  <Modal>
    <Modal.Title>Resubscribe to {{ billing?.plan.name }}</Modal.Title>
    <Modal.Body>
      <p class="text-[14px] leading-[22px] text-gray-800">
        <template v-if="hasOutstandingBalance"
          >Your subscription was cancelled on {{ cancelledDate }}. To
          resubscribe, you'll be charged your
          <span class="font-medium"
            >outstanding balance of {{ outstandingBalance }}</span
          >. This includes any unpaid fees on your account and the cost of
          restarting your plan.</template
        >
        <template v-else
          >Your subscription was previously cancelled. To resubscribe, you'll
          confirm your payment method in the next step.</template
        >
      </p>

      <p
        v-if="hasOutstandingBalance"
        class="mt-4 text-[14px] leading-[22px] text-gray-800"
      >
        You'll confirm payment in the next step.
      </p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="stroke" @click="close()">Cancel</Button>
      <Button variant="primary" @click="handleContinue">Continue</Button>
    </Modal.Footer>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { Modal, Button, useModal } from '@dacr/library'

import { formatTimestamp } from '@/shared/utils/datetime'
import { useBillingStore } from '@/features/billing/store'
import { closeAllModals } from '@/shared/dialogs/modals'
import { openDialog, Dialog } from '@/shared/dialogs/dialog'
import { useOutstandingBalance } from '@/shared/dialogs/account/closure/useOutstandingBalance'

const { close } = useModal()
const billingStore = useBillingStore()
const { hasOutstandingBalance, outstandingBalance } = useOutstandingBalance()

const billing = computed(() => billingStore.billing)

const cancelledDate = computed(() => {
  const date = billing.value?.plan.dateInfo?.date
  return date ? formatTimestamp(date, { formatString: 'LLLL d, yyyy' }) : ''
})

const handleContinue = () => {
  closeAllModals()
  openDialog(Dialog.ResubscribePayment)
}
</script>
